export interface LoginSuccessParams {
  accessToken: string;
  expiresIn: string;
  idToken: string;
  issuedAt: string;
  refreshToken: string;
  tokenType: string;
}

export interface ExpireSuccessParams {
  expire: boolean;
  error: string;
}

export interface RefreshTokenSuccessParams {
  accessToken: string;
  issuedAt: string;
  expiresIn: string;
  tokenType: string;
  refreshToken: string;
  error?: string;
}

export interface APICredentials extends LoginSuccessParams {
  lastUsed: string;
}

export interface RegisterSuccessParams {
  registered: true;
}

export interface ResetPasswordSuccessParams {
  passwordChanged: boolean;
  errorText?: string;
}

export interface User {
  isBankAnalyst: boolean;
  hasManagedService: boolean;
  credentials: APICredentials;
  username: string;
  isAuthenticated: boolean;
  errorMessage: string;
  userId: string;
  qaTeams: string[];
}

export interface DecodedIdToken {
  clientUser: "true" | "false";
  reviewSpreadContract: "true" | "false";
  email: string;
  qaTeams: string;
}

export const NotLoggedInUser = {
  credentials: {
    accessToken: "",
    expiresIn: "",
    idToken: "",
    issuedAt: "",
    refreshToken: "",
    tokenType: "",
    lastUsed: ""
  },
  isAuthenticated: false,
  errorMessage: "",
  username: "",
  isBankAnalyst: false,
  hasManagedService: false,
  userId: "",
  qaTeams: []
};



// WEBPACK FOOTER //
// ./src/login/types.ts